import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxEchartsModule } from "ngx-echarts";
import { SharedModule } from "../../../../shared/shared.module";
import { MaterialModule } from "../../../../shared/material.module";
import { SegyViewerComponent } from "./segy-viewer.component";
import { GatherViewerComponent } from "../gather-viewer/gather-viewer.component";
import { SegyFieldSelectComponent } from "../field-select/field-select.component";
import { SegySpectrumChartComponent } from "../spectrum-chart/spectrum-chart.component";
import { SegyGeometryMapComponent } from "../geometry-map/geometry-map.component";
import { SegyHeaderCrossplotComponent } from "../header-crossplot/header-crossplot.component";
import { SegyHeaderTracksComponent } from "../header-tracks/header-tracks.component";
import { NzPopoverModule } from "ng-zorro-antd/popover";

@NgModule({
  declarations: [
    SegyViewerComponent,
    GatherViewerComponent,
    SegyFieldSelectComponent,
    SegySpectrumChartComponent,
    SegyGeometryMapComponent,
    SegyHeaderCrossplotComponent,
    SegyHeaderTracksComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    NgxEchartsModule,
    NzPopoverModule,
  ],
})
export class SegyViewerModule {}
